import React, { FunctionComponent } from 'react';

import { CollapseBreakpoint } from '../../constants';
import { ToolbarButton } from '../../toolbar-buttons/toolbar-button';
import { useSummarizationControlProps } from './use-summarization-control-props';

export interface SummarizationButtonProps {
    collapseBreakpoit?: CollapseBreakpoint | null;
}

export const SummarizationButton: FunctionComponent<SummarizationButtonProps> = ({
    collapseBreakpoit = CollapseBreakpoint.DEFAULT,
}) => {
    const controlProps = useSummarizationControlProps();

    const { title, tooltip, onMouseEnter, onMouseLeave, ...props } = controlProps;

    return (
        <div onMouseEnter={onMouseEnter} onMouseLeave={onMouseLeave}>
            <ToolbarButton {...props} collapseBreakpoint={collapseBreakpoit} tooltip={tooltip} title={title} />
        </div>
    );
};
